import Swal from "sweetalert2";
import { HttpConstants } from "../../protocols/http/http-constants";
import { HttpPutClient } from "../../protocols/http/http-put-client";
import { UnlockUser } from "../../../domain/useages/user-management/unlock-user";

export class RemoteUnlockUser implements UnlockUser {
  constructor(
    private readonly url: string,
    private readonly httpPutClient: HttpPutClient
  ) {}

  async unlock(user_id: string, params?: UnlockUser.Params): Promise<any> {
    const httpResponse = await this.httpPutClient.put({
      url: this.url.replace(":user_id", user_id.toString()),
      body: params,
      headers: {
        [HttpConstants.CONTENT_TYPE]: HttpConstants.APPLICATION_JSON,
        [HttpConstants.ACCEPT]: HttpConstants.APPLICATION_JSON,
         [HttpConstants.APP_ID]: HttpConstants.APP_ID_VALUE,
      },
      authHeaders: true,
    });
    if (httpResponse.status === 200) {
      Swal.fire({
        timer: 3000,
        icon: "success",
        text: "User Unlocked Successfully",
      });
      return httpResponse.body ? httpResponse.body : httpResponse.data;
    } else {
      Swal.fire({
        timer: 3000,
        icon: "error",
        text: "Some Error Occured",
      });
      return "";
    }
  }
}
